"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPlaceholder = void 0;
var react_1 = __importStar(require("react"));
var cards_ph1_jpg_1 = __importDefault(require("../../../../assets/images/cards_ph1.jpg"));
var cards_ph2_jpg_1 = __importDefault(require("../../../../assets/images/cards_ph2.jpg"));
var cards_ph3_jpg_1 = __importDefault(require("../../../../assets/images/cards_ph3.jpg"));
var styled_components_1 = __importDefault(require("styled-components"));
var mixins_1 = require("../../../../themes/mixins");
var StyledImg = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: 0.7;\n ", ";\n"], ["\n  opacity: 0.7;\n ", ";\n"])), (0, mixins_1.transition)('opacity'));
var CardPlaceholder = function (_a) {
    var _b = _a.style, style = _b === void 0 ? { height: 'auto', width: '100%' } : _b;
    var placeholders = {
        ph1: cards_ph1_jpg_1.default,
        ph2: cards_ph2_jpg_1.default,
        ph3: cards_ph3_jpg_1.default
    };
    //useRef cuz we want this int only one time, which is on first mount.
    //else, everytime the parent comp rerenders, the placeholder changes, which looks quite bad
    var randomInt = (0, react_1.useRef)(Math.ceil(Math.random() * 3)); //will give us 1,2 or 3
    return react_1.default.createElement(StyledImg, { id: 'CardPlaceholder', style: style, src: placeholders["ph".concat(randomInt.current)] });
};
exports.CardPlaceholder = CardPlaceholder;
var templateObject_1;
